export let loading = 0;
export let loadingProgress = 100;
let loadingInterval: any = null;

let loader: any = null
export const registerLoader = (h: (progress: number) => void) => {
    loader = h
}

export const startLoadind = () => {
    if (loadingInterval !== null) {
        clearInterval(loadingInterval);
        loadingInterval = null;
    }
    loading++;
    loadingInterval = setInterval(() => {
        loadingProgress /= 2
        if (loader) loader(loadingProgress)
    }, 50)
}

export const stopLoadind = () => {
    loading--;
    if (loading <= 0) {
        clearInterval(loadingInterval);
        loadingInterval = null;
        loadingProgress = 100;
        if (loader) loader(loadingProgress)
    }
}